import {Component} from '@angular/core';

interface Capability {
  icon: string;
  label: string;
  link: string;
}

interface Priority {
  icon: string;
  title: string;
  description: string;
  tone: 'green' | 'teal' | 'lime' | 'blue';
}

@Component({
  selector: 'edc-demo-introduction',
  templateUrl: './introduction.component.html',
  styleUrls: ['./introduction.component.scss']
})
export class IntroductionComponent {

  // External resources
  readonly aboutUrl = 'https://www.greendealdata.eu/';
  readonly websiteUrl = this.aboutUrl;
  readonly documentationUrl = 'https://frameworks.greendealdata.eu';
  readonly onboardingPortalUrl = 'https://onboarding-portal.62.3.175.232.nip.io';

  readonly capabilities: Capability[] = [
    {icon: 'search', label: 'Browse available datasets and services', link: '/browse-catalog'},
    {icon: 'handshake', label: 'Negotiate access under provider-defined policies', link: '/browse-catalog'},
    {icon: 'download', label: 'Transfer data securely between participants', link: '/transfer-history'},
    {icon: 'upload', label: 'Publish and manage your own assets', link: '/my-assets'},
    {icon: 'assignment', label: 'Monitor contracts and transfer history', link: '/contracts'},
    {icon: 'policy', label: 'Apply and manage policies for your assets', link: '/policies'},
  ];

  readonly priorities: Priority[] = [
    {icon: 'eco', title: 'Biodiversity', description: 'Protecting and restoring nature and ecosystems.', tone: 'green'},
    {icon: 'public', title: 'Climate Adaptation', description: 'Building resilience to climate change impacts.', tone: 'teal'},
    {icon: 'autorenew', title: 'Circular Economy', description: 'Promoting resource efficiency and reuse.', tone: 'lime'},
    {icon: 'water_drop', title: 'Zero Pollution', description: 'Reducing pollution for a healthier environment.', tone: 'blue'},
  ];
}
